/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Quotas_Pagination_PrevInputs */



/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Sub_Quotas_Pagination_PrevInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_pagination_prev = /** @type {((inputs?: Sub_Quotas_Pagination_PrevInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Pagination_PrevInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurück")
	return /** @type {LocalizedString} */ ("Previous")
});